import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect, useDispatch } from 'react-redux';
import { getWorkers, deleteWorker, updateWorkersPagination } from '../../store/actions/worker/worker_action';
import { makeStyles, Paper, Table, TableBody, TableCell, TableHead, TableRow } from '@material-ui/core';
import TablePagination from '../ui_components/table_pagination';
import { REACT_ROUTES } from '../../constants/react_routes';
import history from '../../services/history';
import ActionsComponent from '../ui_components/actions_component';

const useStyles = makeStyles((theme) => ({
	paper: {
        width: '100%',
        marginTop: theme.spacing(3),
        overflowX: 'auto'
    },
    table: {
        minWidth: 500
    }
}));

const WorkersTable = ({ workers: { collection, totalCount, page, rowsPerPage, filters } }) => {
    const { paper, table, tableRow } = useStyles();
    const dispatch = useDispatch();

    useEffect(() => {
        if (!collection.length) {
            dispatch(getWorkers({ page, rowsPerPage, filters }));
        }
    }, []);

    const handleClick = (uuid) => {
        history.push(`${REACT_ROUTES.WORKER}/${uuid}`);
    }

    const handleDeleteWorker = (uuid) => {
        dispatch(deleteWorker(uuid))
            .then(() => dispatch(getWorkers({ page, rowsPerPage, filters })));
    }

    return (
        <Paper className={paper}>
            <Table aria-label="table" className={table}>
                <TableHead>
                    <TableRow>
                        <TableCell align="center">Ime i prezime</TableCell>
                        <TableCell align="center">Tip radnika</TableCell>
                        <TableCell align="center">Email</TableCell>
                        <TableCell align="center">Telefon</TableCell>
                        <TableCell align="right">Akcije</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {collection.map(({ uuid, firstName, lastName, email, phone, deletable, workerType }, index) =>
                        <TableRow hover key={index} className={tableRow}>
                            <TableCell align="center">
                                { firstName } { lastName }
                            </TableCell>
                            <TableCell align="center">{ workerType }</TableCell>
                            <TableCell align="center">{ email }</TableCell>
                            <TableCell align="center">{ phone }</TableCell>
                            <TableCell align="right">
                                <ActionsComponent
                                    handleEdit={() => handleClick(uuid)}
                                    handleDelete={() => handleDeleteWorker(uuid)}
                                    deletable={deletable}
                                    label="radnika"
                                />
                            </TableCell>
                        </TableRow>
                    )}
                </TableBody>
                <TablePagination
                    page={page}
                    count={totalCount}
                    rowsPerPage={rowsPerPage}
                    filters={filters}
                    updatePagination={updateWorkersPagination}
                 />
            </Table>
        </Paper>
    )
}

WorkersTable.propTypes = {
    workers: PropTypes.object
}

const mapStateToProps = (state) => ({
    workers: state.workers
});

export default connect(mapStateToProps)(WorkersTable);
